var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mv-iframe-container"},[_c('iframe',{staticClass:"mv-iframe-responsive",style:({'height': _vm.iframeHeight}),attrs:{"width":"100%","src":_vm.facebookLiveUrl(),"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }